import { useState } from "react"
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import { Button, Form, Container } from "semantic-ui-react";
import { server } from "../../../App";
import { useQuery } from "react-query";
import { getAllMutu } from "../../Api/api";
import { useSelector, useDispatch } from "react-redux";
import {
  selectPatientelleGrid,
  form_load,
} from "../../../features/patientelle/patientelleSlice";
import { toast } from "react-toastify";
import SpeedDialComponent from "../../SpeedDial/SpeedDialComponent"
import useGetDoctors from "../../../CustomHooks/useGetDoctors";

function UpdatePatientelle() {
  const dispatch = useDispatch();
  const PatientelleGridState = useSelector(selectPatientelleGrid);
  const { register, handleSubmit } = useForm();
  const mutuelles = useQuery("mutuelles", () => getAllMutu());
  const location = useLocation();
  const [time, setTime] = useState(false)
  const data = useGetDoctors()

  if (time) {
    setTimeout(() => setTime(false), 1000);
  }

  const updateOneUser = (data) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}users/${data.idpatient}`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        dispatch(form_load(response.data[0]));
        toast.success("Successfully updated", {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  sessionStorage.setItem("ID_Session", PatientelleGridState.idpatient);

  const onSubmit = (data) => {

    if (data.fk_id_medecin === "") {
      data.fk_id_medecin = PatientelleGridState?.fk_id_medecin
    }

    updateOneUser(data);
    setTime(true)
  };

  let mutu_list = "";

  if (mutuelles?.data) {
    mutu_list = (
      <>
        <select
          name="fk_id_liste_mutuelle"
          // role="listbox"
          // aria-expanded="false"
          className="ui selection dropdown"
          defaultValue={PatientelleGridState.fk_id_liste_mutuelle}
          required
          {...register("fk_id_liste_mutuelle")}
        >
          <option className="item" value={0}>
            choisissez une option
          </option>
          {mutuelles?.data.map((item, index) => (
            <option className="item" key={index} value={item.id_liste_mutuelle}>
              {item.nom_mutuelle}
            </option>
          ))}
        </select>
      </>
    );
  }
  return (
    <>
      <div>
        {location.pathname === "/UpdatePatientelle" ? <br /> : null}
        {location.pathname === "/UpdatePatientelle" ? <br /> : null}

        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <Form.Group className="MyForm" widths="equal">
              <div className="required field">
                <label>Civilite</label>
                <select
                  name="fk_id_civilite"
                  // role="listbox"
                  // aria-expanded="false"
                  className="ui selection dropdown"
                  defaultValue={PatientelleGridState.fk_id_civilite}
                  required
                  {...register("fk_id_civilite")}
                >
                  <option className="item" value={0}>
                    choisissez une option
                  </option>
                  <option className="item" value="1">
                    Madame
                  </option>
                  <option className="item" value="2">
                    Monsieur
                  </option>
                  <option className="item" value="3">
                    Mademoiselle
                  </option>
                  <option className="item" value="4">
                    Enf.
                  </option>
                  <option className="item" value="5">
                    Bébé
                  </option>
                </select>
              </div>

              <div style={{ display: "none" }}>
                <label>ID</label>
                <div className="ui input">
                  <input
                    name="idpatient"
                    defaultValue={PatientelleGridState.idpatient}
                    {...register("idpatient")}
                  />
                </div>
              </div>

              <div className="required field">
                <label>Nom</label>
                <div className="ui input">
                  <input
                    name="nom"
                    maxLength={40}
                    required
                    type="text"
                    defaultValue={PatientelleGridState.nom}
                    {...register("nom")}
                  />
                </div>
              </div>

              <div className="required field">
                <label>Prenom</label>
                <div className="ui input">
                  <input
                    name="prenom"
                    maxLength={40}
                    required
                    type="text"
                    defaultValue={PatientelleGridState.prenom}
                    {...register("prenom")}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group className="MyForm" widths="equal">

              <div className="required field">
                <label>Date de naissance</label>
                <div className="ui input">
                  <input
                    type="date"
                    name="date_naissance"
                    defaultValue={PatientelleGridState.DATE_NAISSANCE_SERVER}
                    required
                    min="1900-01-01"
                    max="3018-12-31"
                    {...register("date_naissance")}
                  ></input>
                </div>
              </div>
              <div className="required field">
                <label>Mutuelle</label>

                {mutu_list}
              </div>
              <div className="required field">
                <label>Medecin</label>
                <select
                  defaultValue={PatientelleGridState?.fk_id_medecin}
                  name="fk_id_medecin"
                  // role="listbox"
                  aria-expanded="false"
                  className="ui selection dropdown"
                  required
                  {...register("fk_id_medecin")}
                >
                  {data?.Doctors_list}
                </select>
              </div>



            </Form.Group>
            <Form.Group className="MyForm" widths="equal">
              <div className=" field">
                <label>Tel</label>
                <div className="ui input">
                  <input
                    name="tel"
                    maxLength={10}
                    type="text"
                    defaultValue={PatientelleGridState.tel}
                    {...register("tel")}
                  />
                </div>
              </div>

              <div className=" field">
                <label>Tel2</label>
                <div className="ui input">
                  <input
                    name="tel2"
                    maxLength={10}
                    type="text"
                    defaultValue={PatientelleGridState.tel2}
                    {...register("tel2")}
                  />
                </div>
              </div>

              <div className=" field">
                <label>Tel3</label>
                <div className="ui input">
                  <input
                    name="tel3"
                    maxLength={10}
                    type="text"
                    defaultValue={PatientelleGridState.tel3}
                    {...register("tel3")}
                  />
                </div>
              </div>

            </Form.Group>

            <Form.Group className="MyForm">

              <div className=" field">
                <label>CIN</label>
                <div className="ui input">
                  <input
                    name="cin"
                    maxLength={10}
                    type="text"
                    defaultValue={PatientelleGridState.cin}
                    {...register("cin")}
                  />
                </div>
              </div>

              <div className=" field">
                <label>Commentaire</label>
                <div className="ui form">
                  <textarea
                    placeholder="Commentaire"
                    name="commentaire_sur_patient"
                    maxLength={1000}
                    type="text"
                    defaultValue={PatientelleGridState.commentaire_sur_patient}
                    {...register("commentaire_sur_patient")}
                    rows="3"
                  />
                </div>
              </div>

            </Form.Group>
            {location.pathname === "/UpdatePatientelle" ? null : <br />}
            <Button className="someMarginTopQuerry" floated="right" positive disabled={time}>
              Valider
            </Button>

          </Form>


        </Container>
        <br></br>
        <br></br>
        {location.pathname === "/Consultation" ? null : <br></br>}
        {location.pathname === "/Consultation" ? null : <br></br>}
        {location.pathname === "/Consultation" ? null : <br></br>}
        {location.pathname === "/Consultation" ? null : <br></br>}
        {location.pathname === "/Consultation" ? null : <SpeedDialComponent />}

      </div>
    </>
  );
}

export default UpdatePatientelle;
